module.exports = __webpack_public_path__ + "img/icon-arrow--next.229b545f.svg";